import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../hooks';
import { Diagnosis, DiagnosisCategory } from '../types';
import qs from 'qs';

type Props = {
  category?: DiagnosisCategory[];
  core?: boolean;
};

export const useDiagnosis = ({ category, core }: Props = {}) => {
  const { api } = useApi();

  const fetchDiagnosis = async (): Promise<Diagnosis[]> => {
    const queryStr = qs.stringify(
      { category, core },
      { arrayFormat: 'repeat' }
    );

    const results = await api({
      route: `/diagnosis/${queryStr ? `?${queryStr}` : ''}`,
    });

    return results.filter((item: Diagnosis) => !!item.category);
  };

  const { data, isLoading, isError } = useQuery<Diagnosis[], Error>({
    queryKey: ['public-diagnosis', category, core],
    queryFn: fetchDiagnosis,
    placeholderData: [],
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    isError,
    data,
  };
};
